import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { LOGO, NAV_LINKS, SITE } from '../../app.const';

function Navbar() {
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsCompact(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`Navbar ${isCompact ? 'is-compact' : ''}`}>
      <NavLink to="/" className="Navbar-brand">
        <img className="Navbar-mark" src={LOGO.mark.src} alt="" />
        {SITE.name}
      </NavLink>
      <ul className="Navbar-links">
        {NAV_LINKS.map((link) => (
          <li key={link.path}>
            <NavLink
              to={link.path}
              end={link.path === '/'}
              className={({ isActive }) =>
                isActive ? 'Navbar-link active' : 'Navbar-link'
              }
            >
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Navbar;
